import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterByDateModal } from "../../../store/supervisorRequiredDocuments";
import { selectCreatedAtFilter } from "../../../store/supervisorRequiredDocuments/selectors/selectCreatedAtFilter";
import { create } from "domain";
const dateFormat = new Intl.DateTimeFormat("es-MX");

export const FilterDateChip = () => {
  const dispatch = useDispatch();
  const createdAtFilter = useSelector(selectCreatedAtFilter);
  return (
    <IonChip
      onClick={() => dispatch(setFilterByDateModal(true))}
      outline
      color={createdAtFilter.from ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {createdAtFilter.from || createdAtFilter.to ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Fecha: </span>
            {createdAtFilter.from && "desde" + dateFormat.format(new Date(createdAtFilter.from))}
            {createdAtFilter.to && " hasta " + dateFormat.format(new Date(createdAtFilter.to))}
          </IonText>
        ) : (
          <span>Fecha: Cualquiera</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
